import { z } from "zod";
import { MetaSchema } from "./shared";

export const userSchema = z.object({
  id: z.string().uuid(),
  uuid: z.string(),
  isActivePlan: z.boolean(),
  isActive: z.boolean(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  gender: z.string().nullable(),
  role: z.string(),
  rank: z.string().nullable(),
  username: z.string().nullable(),
  email: z.string().nullable(),
  avatar: z.string().nullable(),
  activatedPlanAt: z.string().nullable(),
  createdAt: z.string(),
  deletedAt: z.string().nullable(),
});

export const walletConvertItemSchema = z.object({
  id: z.string().uuid(),
  amountConverted: z.string(),
  amount: z.string(),
  conversionRate: z.string(),
  createdAt: z.string(),
  conversionType: z.string(),
  user: userSchema,
});

export const metaSchema = z.object({
  path: z.string(),
  tracerId: z.string(),
  duration: z.string(),
  method: z.string(),
});

export const getWalletsConvertsSchema = z.object({
  data: z.tuple([
    z.array(walletConvertItemSchema),
    z.number(),   
  ]),
  meta: MetaSchema.default,
});

export type GetWalletsConvertsResponse = z.infer<
  typeof getWalletsConvertsSchema
>;
export type WalletConvertItem = z.infer<typeof walletConvertItemSchema>;